@if (recentAction) {
  <ds-accordion-category class="list" [title]="nextSteps" [isOpen]="true">
    @if (recentAction === 'Enrolled All' || recentAction === 'Enrolled Operator') {
      <div>
        @if (policyState !== 'WA' && policyState !== 'SD') {
          <div>
            <p
              class="pad-bottom-20"
              dsContent
              [contentPath]="'kydSmartphonePhh.successMessage'"
            ></p>
            <p
              class="pad-bottom-20"
              dsContent
              [contentPath]="'kydSmartphonePhh.initiateProgramText'"
              [options]="emailIdProp"
            ></p>
          </div>
        }
        @if (policyState === 'WA' || policyState === 'SD') {
          <p
            dsContent
            [contentPath]="'kydSmartphonePhh.successMessageNoTPM'"
            [options]="emailIdProp"
          ></p>
        }
        @if (policyState === 'SD') {
          <p dsContent [contentPath]="'kydSmartphonePhh.tpmDisclaimerSD'"></p>
        }
      </div>
    }
    @if (recentAction === 'Phone Updated') {
      <div>
        <p class="pad-bottom-20" dsContent [contentPath]="'kydSmartphonePhh.updatePhone'"></p>
        <p class="pad-bottom-20" dsContent [contentPath]="'kydSmartphonePhh.sendTextToNewNum'"></p>
        <p dsContent [contentPath]="'kydSmartphonePhh.installAppText'"></p>
      </div>
    }
    @if (recentAction === 'Unenrolled Operator' && isPolicyEnrolled) {
      <div>
        <p class="pad-bottom-20" dsContent [contentPath]="'kydSmartphonePhh.removeDriverText'"></p>
        <p dsContent [contentPath]="'kydSmartphonePhh.renewalText'"></p>
      </div>
    }
    @if (
      recentAction === 'Unenrolled All' ||
      (recentAction === 'Unenrolled Operator' && !isPolicyEnrolled)
    ) {
      <div>
        <p
          class="pad-bottom-20"
          dsContent
          [contentPath]="'kydSmartphonePhh.allDriversRemovedText'"
        ></p>
        @if (policyState !== 'WA') {
          <p class="pad-bottom-20" dsContent [contentPath]="'kydSmartphonePhh.unenrollAllTPM'"></p>
        }
        <p class="pad-bottom-20" dsContent [contentPath]="'kydSmartphonePhh.newPremium'"></p>
        <p dsContent [contentPath]="'kydSmartphonePhh.importantText'"></p>
      </div>
    }
  </ds-accordion-category>
}
